import React, { useContext, useEffect, useState } from "react";
import "../styles/listsSetup.css";
import ProfileDetailsTab from "../components/ListsSetup/ProfileDetailsTab";
import ProjectDetailsTab from "../components/ListsSetup/ProjectDetailsTab";
import ReviewTab from "../components/ListsSetup/ReviewTab";
import DatabaseResult from "../components/ProjectDetails/DatabaseResult";
import { UrlContext } from "../contexts/UrlContext";

export default function ListsSetup() {
  useEffect(() => {
    document.title = "List Setup";
  }, []);
  const { API_URL } = useContext(UrlContext);
  const [experts, setExperts] = useState([]);
  const [project_id, setProject_id] = useState("");
  const [activeTab, setActiveTab] = useState("projectDetails");
  const [languages, setLanguages] = useState([]);
  const [skills, setSkills] = useState([]);
  const [projCategory, setProjCategory] = useState([]);
  const [spacialLanguages, setSpacialLanguages] = useState([
    {
      code: "ar",
      name: "Arabic",
      type: "Mostly used",
    },
    {
      code: "zh",
      name: "Chinese",
      type: "Mostly used",
    },
    {
      code: "en",
      name: "English",
      type: "Mostly used",
    },
    {
      code: "fr",
      name: "French",
      type: "Mostly used",
    },
    {
      code: "de",
      name: "German",
      type: "Mostly used",
    },
    {
      code: "pt",
      name: "Portuguese",
      type: "Mostly used",
    },
    {
      code: "es",
      name: "Spanish",
      type: "Mostly used",
    },
  ]);

  const [data, setData] = useState({
    leadEmail: "",
    projectName: "",
    projectDescription: "",
    projectRegion: "",
    projectLocation: "",
    projectConsultantType: "",
    projectIndustyPreference: "No",
    projectIndustyPreferenceList: [],
    projectDailyBudget: "",
    projectCategory: "",
    projectSkillsRequirements: [],
    projectSuggestedSkills: [],
    projectLanguages: [],
    projectSeniority: [],
    projectStartDateOption: "",
    projectStartDate: "",
    projectDuration: "",
    projectTypeOfEmployment: "",
    projectRemoteOption: "",
    projectOnsiteOption: "",
    clientOwner: "",
  });

  useEffect(() => {
    const url = `${API_URL}project-setup-data`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setLanguages(data.language);

        let newSkills = [];
        data.skillList.forEach((skill) => {
          newSkills.push({ label: skill, value: skill });
        });
        setSkills(newSkills);

        let newProjCategory = data.projCategory;
        let Data_and_Business_Analytics =
          newProjCategory["Data & Business Analytics"];
        const skills = Object.keys(
          Data_and_Business_Analytics["Big Data & Analytics"][0]
        ).map((skill) => {
          return Data_and_Business_Analytics["Big Data & Analytics"][0][skill];
        });
        Data_and_Business_Analytics["skills"] = skills;
        newProjCategory["Data & Business Analytics"] =
          Data_and_Business_Analytics;
        setProjCategory(newProjCategory);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      {experts.length ? (
        <DatabaseResult searchResults={experts} projectId={project_id} />
      ) : (
        <div className="container-fluid">
          <div className="row m-justify-content-center">
            <div className="prj-setup-container col-xl-8 text-center mb-2">
              <div className="card px-0 pt-4 pb-0 mb-3">
                <h2 id="prjsetup-heading">List Setup</h2>
                <div id="project-setup-form">
                  <ul id="progressbar">
                    <li className="active" id="account">
                      <strong>List Details</strong>
                    </li>
                    <li
                      className={
                        activeTab === "profileDetails" || activeTab === "finish"
                          ? "active"
                          : ""
                      }
                      id="personal"
                    >
                      <strong>Profile Details</strong>
                    </li>
                    <li
                      className={activeTab === "finish" ? "active" : ""}
                      id="confirm"
                    >
                      <strong>Review</strong>
                    </li>
                  </ul>
                  <div
                    className={activeTab === "projectDetails" ? "" : "d-none"}
                  >
                    <ProjectDetailsTab
                      setActiveTab={setActiveTab}
                      data={data}
                      setData={setData}
                      projCategory={projCategory}
                    />
                  </div>
                  <div
                    className={activeTab === "profileDetails" ? "" : "d-none"}
                  >
                    <ProfileDetailsTab
                      spacialLanguages={spacialLanguages}
                      setActiveTab={setActiveTab}
                      data={data}
                      setData={setData}
                      projCategory={projCategory}
                      skills={skills}
                      setSkills={setSkills}
                      languages={languages}
                    />
                  </div>
                  <div className={activeTab === "finish" ? "" : "d-none"}>
                    <ReviewTab
                      setActiveTab={setActiveTab}
                      data={data}
                      setExperts={setExperts}
                      setProject_id={setProject_id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
